import CheckboxTreeApiResponseDto from "../../types/dtos/admin/CheckboxTreeApiResponseDto";
import { apiClient } from "../apiClient";

class locationApi {
  constructor(authToken: string | undefined) {
    this.accessToken = authToken;
  }

  accessToken: string | undefined;

  /** Loads all non-deleted client locations ready for a checkbox tree component */
  getLocationCheckboxTreeItemsByClientId(
    /** If true, the locations will be restricted by the brand access (if applicable) */
    restrictByBrandAccess: boolean,
    onSuccess: (locations: CheckboxTreeApiResponseDto) => void,
    onError: (error: any) => void
  ) {
    return apiClient(
      this.accessToken,
      "dashboards/location/get-location-checkbox-tree-items-by-client-id?restrictByBrandAccess=" +
        restrictByBrandAccess
    ).then(
      (data) => {
        const locations = data as CheckboxTreeApiResponseDto;
        onSuccess(locations);
      },
      (error) => {
        onError(error);
      }
    );
  }
}

export default locationApi;
